import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import 'isomorphic-fetch';
import { polyfill } from 'es6-promise';
import {
	OFLC_REJECT_INVITATION,
	rejectInvitationSuccess,
	rejectInvitationFail
} from '../actions/action_rejectInvitation';
import util from '../../../global/utils/Helpers';
polyfill();

let apiIndex = util.isLocalhost() ? 'http://localhost:9393/auth/graphql' : `${util.getCurrentHost()}/auth/auth/graphql`;

const getQuery = (data) => {
	console.log('rejectInvitation', data);
	return JSON.stringify({
		query: `
            mutation {
			rejectInvitation(email:"${data.recipientEmail}",group_id:"${data.groupId}")
          }`
	});
};
const rejectUserDataEpic = (action$) =>
	action$.pipe(
		ofType(OFLC_REJECT_INVITATION),
		mergeMap((action) =>
			fetch(apiIndex, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getQuery(action.payload)
			})
				.then((response) => response.json())
				.then((data) => rejectInvitationSuccess(data))
				.catch((error) => rejectInvitationFail(true))
		)
	);

export default rejectUserDataEpic;
